import { messageList, addMessage, editMessage } from './request';
export default {
  data() {
    return {
      form: {
        name: '',
        code: ''
      },
      columns: [{
        dataIndex: 'index',
        width: 80,
        slots: {
          title: '序号'
        },
        align: 'center'
      }, {
        dataIndex: 'name',
        width: 200,
        slots: {
          title: '短信名称'
        },
        align: 'center'
      }, {
        dataIndex: 'code',
        width: 200,
        slots: {
          title: 'code值'
        },
        align: 'center'
      }, {
        width: 200,
        slots: {
          title: '短信内容'
        },
        scopedSlots: {
          customRender: 'content'
        },
        align: 'center'
      }, {
        width: 200,
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      messageForm: {
        name: '',
        code: '',
        content: ''
      },
      addVisible: false,
      editMessageItem: null,
      saveLoading: false
    };
  },
  computed: {
    messageRules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('短信名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: this.$t('请输入1-20字符'),
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: this.$t('请输入code值'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: this.$t('请输入1-20字符'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('短信内容'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: this.$t('请输入1-200字符'),
          trigger: 'blur'
        }]
      };
    }
  },
  mounted() {
    this.getMessageList();
  },
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getMessageList();
    },
    reset() {
      this.$refs.form.resetFields();
      this.pagination.current = 1;
      this.getMessageList();
    },
    getMessageList() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.form.name.trim(),
        code: this.form.code.trim()
      };
      messageList(params).then(res => {
        this.data = res.items || [];
        this.pagination.total = Number(res.totalNum) || 0;
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getMessageList();
    },
    openAddModal(record) {
      if (record) {
        this.editMessageItem = record;
        this.messageForm = {
          name: record.name,
          code: record.code,
          content: record.content
        };
      } else {
        this.editMessageItem = null;
      }
      this.addVisible = true;
    },
    saveAdd() {
      if (this.saveLoading) return;
      this.$refs.addRef.validate(valid => {
        if (valid) {
          let params = {
            name: this.messageForm.name.trim(),
            content: this.messageForm.content.trim()
          };
          if (this.editMessageItem) {
            params.noteId = this.editMessageItem.id;
            this.saveLoading = true;
            editMessage(params).then(res => {
              this.$message.success(this.$t('编辑成功'));
              this.closeAddVisible();
              this.getMessageList();
              this.editMessageItem = null;
            }).finally(() => {
              this.saveLoading = false;
            });
          } else {
            params.code = this.messageForm.code.trim();
            this.saveLoading = true;
            addMessage(params).then(res => {
              this.$message.success(this.$t('新增成功'));
              this.closeAddVisible();
              this.getMessageList();
            }).finally(() => {
              this.saveLoading = false;
            });
          }
        }
      });
    },
    closeAddVisible() {
      this.$refs.addRef.resetFields();
      this.addVisible = false;
      this.editMessageItem = null;
      this.messageForm = {
        name: '',
        code: '',
        content: ''
      };
    }
  }
};